var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('game',{attrs:{"mud-id":_vm.mudId,"character-id":_vm.characterId}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }